import type { ReactNode } from 'react';
import { entryKey, type UnplacedEntry } from '../plans/edit';

export interface UnplacedListProps {
  entries: UnplacedEntry[];
  /** `entryKey` of the entry waiting for its position. */
  selected: string | undefined;
  /** Tapping the selected entry again deselects it. */
  onSelect: (entry: UnplacedEntry | undefined) => void;
}

/** Side list "Nicht platziert": tap an entry, then tap the plan to place it. */
export function UnplacedList({ entries, selected, onSelect }: UnplacedListProps): ReactNode {
  return (
    <aside className="card unplaced-list" aria-labelledby="unplaced-list-title">
      <h2 id="unplaced-list-title">Nicht platziert</h2>
      {entries.length === 0 ? (
        <p className="muted">Alle Objekte dieses Orts sind platziert.</p>
      ) : (
        <ul>
          {entries.map((entry) => {
            const key = entryKey(entry);
            const active = key === selected;
            return (
              <li key={key}>
                <button
                  type="button"
                  className={`unplaced-list__entry unplaced-list__entry--${entry.refType}`}
                  aria-pressed={active}
                  onClick={() => onSelect(active ? undefined : entry)}
                >
                  {entry.label}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </aside>
  );
}
